import { useContext } from 'react';
import VoiceCallAgentIntegrationContext from '../context/VoiceCallAgentIntegration';

const useVoiceCallAgentIntegration = () =>
  useContext(VoiceCallAgentIntegrationContext);

export default useVoiceCallAgentIntegration;
